import { render, staticRenderFns } from "./AtomAvatarPrimary.vue?vue&type=template&id=1ee9a4b5&"
import script from "./AtomAvatarPrimary.vue?vue&type=script&lang=js&"
export * from "./AtomAvatarPrimary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports